import { createFileRoute } from '@tanstack/react-router'

import { Center, Spinner } from '@/components/ui'
import { TrialListPage } from '@/pages/TrialListPage'

export const Route = createFileRoute(
  '/_authenticated/_with-global-layout/trials/',
)({
  component: RouteComponent,
  pendingComponent: () => {
    return (
      <Center h="svh" w="svw">
        <Spinner />
      </Center>
    )
  },
})

function RouteComponent() {
  return <TrialListPage />
}
